<template>
  <div v-editable="props.stepData" class="step-dynamic">
    <WizcoRichtextResolver :blok="props.stepData.content" />
    <StepFooter @click="wizco.submit()" />
  </div>
</template>

<script setup>
import { useWizcoStore } from '../stores/wizco'
import StepFooter from '../components/footer/StepFooter.vue'
const wizco = useWizcoStore()

const props = defineProps({
  stepData: {
    type: Object,
    required: true
  }
})

wizco.isActiveStepReady = true
</script>
